import React from 'react'
import formatNum from './FormatNum'

export default function CommonPrizeList(props) {
  return (
    <>
        {props.showCommonKey && (
            <div className={"hud-prize-info-el common-key-prize"}>
                <span className={"el-prize-img"} />
                <span className={"el-prize-count"}>
              {formatNum(props.common_key, props.lang)}
            </span>
            </div>
        )}
        {props.showRareKey && (
          <div className={"hud-prize-info-el rare-key-prize"}>
            <span className={"el-prize-img"} />
            <span className={"el-prize-count"}>
              {formatNum(props.rare_key, props.lang)}
            </span>
          </div>
        )}
        {props.showEpicKey && (
          <div className={"hud-prize-info-el epic-key-prize"}>
            <span className={"el-prize-img"} />
            <span className={"el-prize-count"}>
              {formatNum(props.epic_key, props.lang)}
            </span>
          </div>
        )}
        {props.showSnowball && (
          <div className={"hud-prize-info-el snowball-prize"}>
            <span className={"el-prize-img"} />
            <span className={"el-prize-count"}>
              {formatNum(props.snowball, props.lang)}
            </span>
          </div>
        )}
        {props.showKing && (
            <div className={"hud-prize-info-el king-prize"}>
                <span className={"el-prize-img"} />
                <span className={"el-prize-count"}>
              {formatNum(props.king, props.lang)}
            </span>
            </div>
        )}
        {props.showFirework && (
            <div className={"hud-prize-info-el firework-prize"}>
                <span className={"el-prize-img"} />
                <span className={"el-prize-count"}>
              {formatNum(props.firework, props.lang)}
            </span>
            </div>
        )}
        {props.showGrenade && (
          <div className={"hud-prize-info-el grenade-prize"}>
            <span className={"el-prize-img"} />
            <span className={"el-prize-count"}>
              {formatNum(props.grenade, props.lang)}
            </span>
          </div>
        )}
        {props.showDamage && (
          <div className={"hud-prize-info-el damage-prize"}>
            <span className={"el-prize-img"} />
            <span className={"el-prize-count"}>{formatNum(props.damage, props.lang)}</span>
          </div>
        )}
        {props.showBoost && (
          <div className={"hud-prize-info-el boost-prize"}>
            <span className={"el-prize-img"} />
            <span className={"el-prize-count"}>{formatNum(props.boost, props.lang)}</span>
          </div>
        )}
        {props.showRepair && (
          <div className={"hud-prize-info-el repair-prize"}>
            <span className={"el-prize-img"} />
            <span className={"el-prize-count"}>{formatNum(props.repair, props.lang)}</span>
          </div>
        )}
        {props.showProtection && (
          <div className={"hud-prize-info-el protection-prize"}>
            <span className={"el-prize-img"} />
            <span className={"el-prize-count"}>
              {formatNum(props.protection, props.lang)}
            </span>
          </div>
        )}
    </>
  )
}
